import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  goTop() {
    document.querySelector('.web-container-main').scrollTo(0, 0)
  }
}
